import { selectAll } from 'css-select';
import renderImport from 'dom-serializer';
import type { Element, Node } from 'domhandler';
import { replaceElement } from 'domutils';
import { parseDocument } from 'htmlparser2';

import type { RichMediaTransformer } from './types';

// dom-serializer has double-nested default when consumed via CJS interop which doesn't play well with tsup
// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
const render: typeof renderImport =
	// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
	(renderImport as any)?.default?.default ??
	// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
	(renderImport as any)?.default ??
	renderImport;

type TransformTagsParams = {
	html: string;
	transformers: RichMediaTransformer[];
};

export const transformTags = ({ html, transformers }: TransformTagsParams): string =>
	transformers.reduce((transformedHtml, transformer) => {
		const document = parseDocument(transformedHtml);
		const matchingElements = selectAll<Node, Element>(transformer.tagName, document);
		matchingElements.forEach((matchingElement) => {
			const newElement = transformer.transformTagFn(matchingElement);
			replaceElement(matchingElement, newElement);
		});
		return render(document);
	}, html);
